export interface EmergencyOverviewColumn {
  /** Unique identifier for the column */
  field: string;
  /** Column width as a CSS value (px, fr, minmax, etc.) */
  width: string;
  /** Whether the column is visible by default */
  visible: boolean;
}

// IMPORTANT: every row is rendered as its own independent CSS grid, so column
// tracks MUST be content-independent (no `auto`/`max-content`) — otherwise each
// row sizes its columns to its own content and the columns don't line up
// vertically across rows. We therefore use only fixed `px` widths and flexible
// `fr` tracks (both resolve identically for every row given the same container
// width), which keeps all columns aligned across the whole table.
// Fixed columns are kept as tight as their content allows so the flexible text
// columns (arrivalInfo, vessel, berthVisit) get the maximum share of the row.
// The `fr` weights mirror the design's text-column widths (arrivalInfo ~224px,
// vessel ~160px, berthVisit ~346px => a ~1.4 : 1 : 2.15 ratio).
export const EMERGENCY_OVERVIEW_COLUMNS: EmergencyOverviewColumn[] = [
  { field: 'arrivalInfo', width: 'minmax(0, 1.4fr)', visible: true },
  { field: 'serviceStatusHarbour', width: '44px', visible: true },
  { field: 'operations', width: '48px', visible: true },
  { field: 'vessel', width: 'minmax(0, 1fr)', visible: true },
  { field: 'vesselLength', width: '48px', visible: true },
  { field: 'vesselDraught', width: '68px', visible: true },
  { field: 'berthVisit', width: 'minmax(0, 2.15fr)', visible: true },
  { field: 'lastUpdated', width: '80px', visible: true },
  { field: 'nauticalServices', width: '116px', visible: true },
  { field: 'serviceStatusOther', width: '100px', visible: true },
  // 120px holds the 5 icon buttons; the extra width is empty space on the left
  // (buttons are right-aligned) which reads as breathing room between the status
  // dots and the action buttons.
  { field: 'actions', width: '140px', visible: true },
];
